var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"color":"rgba(0,0,0,.5)","font-size":"20px","text-align":"center","cursor":"pointer","margin-top":"30%"},attrs:{"id":"downloadButton"}},[_vm._v("点击下载或打开十角兽APP")])])
}]

export { render, staticRenderFns }